import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  AuthoredEvidence,
  FormAutocomplete,
  FormCheckbox,
  FormLocalDateTimeField,
  FormPanel,
  FormTextField,
} from '@eas/common-web';
import { useAbsenceTypes } from '@modules/absence-type/absence-type-api';

export function AbsenceCreateDialog({ isExisting }: { isExisting: boolean }) {
  const absenceTypesSource = useAbsenceTypes();

  return (
    <>
      {isExisting && (
        <>
          <FormPanel
            defaultExpanded={true}
            label={
              <FormattedMessage
                id="ZSD__ABSENCE__DETAIL__PANEL_LABEL_GENERAL"
                defaultMessage="Obecné"
              />
            }
          />
          <AuthoredEvidence.AuthoredFields />
        </>
      )}
      <FormPanel
        defaultExpanded={true}
        label={
          <FormattedMessage
            id="ZSD__ABSENCE__DETAIL__FIELD_LABEL__DETAILS"
            defaultMessage="Detaily"
          />
        }
      >
        <FormLocalDateTimeField
          name="fromDate"
          label={
            <FormattedMessage
              id="ZSD__ABSENCE__DETAIL__FIELD_LABEL__FROM_DATE"
              defaultMessage="Dátum od"
            />
          }
          representation="local-date-time"
        />

        <FormLocalDateTimeField
          name="toDate"
          label={
            <FormattedMessage
              id="ZSD__ABSENCE__DETAIL__FIELD_LABEL__TO_DATE"
              defaultMessage="Dátum do"
            />
          }
          representation="local-date-time"
        />

        <FormAutocomplete
          name="absenceType"
          source={absenceTypesSource}
          label={
            <FormattedMessage
              id="ZSD__ABSENCE__DETAIL__FIELD_LABEL__ABSENCE_TYPE"
              defaultMessage="Dôvod absencie"
            />
          }
        />
        <FormTextField
          name="note"
          label={
            <FormattedMessage
              id="ZSD__ABSENCE__DETAIL__FIELD_LABEL__NOTE"
              defaultMessage="Poznámka"
            />
          }
        />

        {isExisting && (
          <FormCheckbox
            name="allowed"
            disabled
            label={
              <FormattedMessage
                id="ZSD__ABSENCE__DETAIL__FIELD_LABEL__ALLOWED"
                defaultMessage="Schválená"
              />
            }
          />
        )}
      </FormPanel>
    </>
  );
}
